<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <img
      src="http://gxbg.pangodso.com/file/static/banner_vision.jpg"
      alt=""
      class="banner"
    />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item to="/case">资讯动态</el-breadcrumb-item>
      <el-breadcrumb-item>{{ detail.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <div class="title">{{ detail.title }}</div>
      <div class="rich" v-html="detail.contentStr"></div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      detail: {},
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await this.$api.getNewDetail(this.$route.params.id);
      this.detail = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
}
.content {
  width: 1200px;
  margin: 50px auto;
}
.title {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
}
.rich {
  margin-top: 40px;
}

.m-frame {
  .el-breadcrumb {
    width: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
  }
  .content {
    width: 100%;
    margin: 20px 0;
    padding: 0 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
    }
  }
}
</style>
